module.exports = __webpack_public_path__ + "img/richtext-show.ce1bcc02.png";